import { t } from '@lingui/core/macro'
import { TourStep } from '@tecsinapse-org/portal-menu-kit'
import React from 'react'

export const stepsFirstPage = (save?: () => Promise<void>) => [
  {
    content: (
      <TourStep
        title={t`Adição de Cargos`}
        description={t`Para adicionar um cargo, basta preencher as informações, e após clique no ícone de "+" para adicionar o cargo.`}
      />
    ),
    selector: `#first-cargos-select`
  },
  {
    content: (
      <TourStep
        title={t`Remoção de Cargos`}
        description={t`Para remover um cargo, clique no ícone de "-" no fim da linha.`}
      />
    ),
    selector: `#first-cargos-table`,
    actionAfter: save
  }
]

export const stepsSecondPage = (save?: () => Promise<void>) => [
  {
    content: (
      <TourStep
        title={t`Tipos de Acesso do Usuário`}
        description={t`Para conceder acesso, selecione o perfil do usuário dentro de cada módulo. Após escolher o tipo de Acesso você poderá selecionar as permissões de funcionalidades específicas.`}
      />
    ),
    selector: `#first-product-permissions-select`
  },
  {
    content: (
      <TourStep
        title={t`Permissões`}
        description={t`Defina as funcionalidades específicas que estarão disponíveis ao usuário`}
      />
    ),
    selector: `#first-product-permissions-table`,
    actionAfter: save
  }
]
